import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ProfileForm, ProfileFormValues } from './types'

export interface ICreateProfileState {
  profileForm: ProfileForm
  isAchDebit: boolean
}

const initialState: ICreateProfileState = {
  profileForm: ProfileFormValues,
  isAchDebit: false,
}

export const slice = createSlice({
  name: 'createProfile',
  initialState,
  reducers: {
    onProfileForm: (
      state,
      action: PayloadAction<typeof initialState.profileForm>
    ) => {
      state.profileForm = action.payload
    },
    onIsAchDebit: (
      state,
      action: PayloadAction<typeof initialState.isAchDebit>
    ) => {
      state.isAchDebit = action.payload
    },
  },
})

export const { actions, reducer } = slice

export type ICreateProfile = {
  createProfile: ICreateProfileState
}
